import StyleCommand from 'commands/styleCommand';
import selectionUtils from 'utils/selectionUtils';

function FontFamilyCommand() {
    StyleCommand.call(this, 'span', 'font-family');
}

FontFamilyCommand.prototype = Object.create(StyleCommand.prototype);
FontFamilyCommand.prototype.exec = function (editor, value) {
    StyleCommand.prototype.exec.call(this, editor, value);
    selectionUtils.getSelectedLists(editor).forEach(listElement => this.applyOnElement(value, listElement));
};

FontFamilyCommand.prototype.applyOnElement = function (value, element) {
    element.setStyle('fontFamily', value);
};

export default FontFamilyCommand;
